import React from 'react'

export default () => (
  <svg width="176" height="107" viewBox="0 0 176 107" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M175 1C175.144 36 140.546 106 1 106" stroke="#194074" strokeWidth="2" strokeLinecap="round"/>
  </svg>
)
